import React, { Fragment } from 'react';
import { Link } from "@remix-run/react";
import { jsx as _jsx } from "react/jsx-runtime";
export const SmartLink = ({
  to,
  isInternal,
  children,
  ...rest
}) => /*#__PURE__*/_jsx(Fragment, {
  children: isInternal ? /*#__PURE__*/_jsx(Link, {
    to: to,
    ...rest,
    children: children
  }) : /*#__PURE__*/_jsx("a", {
    href: to,
    ...rest,
    children: children
  })
});